/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  BiLogoTwitter,
  BiLogoInstagramAlt,
  BiLogoLinkedin,
  BiRepeat,
  BiCheckShield,
  BiLogoPlayStore,
  BiLogoApple,
  BiLogoFacebook,
} from "react-icons/bi";
import { footerData } from "../../Constants";
import footerLogo from "../../assets/Home/logoFooter.png";

const Footer = () => {
  const [webview, setWebview] = useState(false);

  const columnCount = 3;
  const rowsPerColumn = Math.ceil(footerData.length / columnCount);

  const columns = Array.from({ length: columnCount }, (_, columnIndex) => {
    const startIndex = columnIndex * rowsPerColumn;
    const endIndex = Math.min(startIndex + rowsPerColumn, footerData.length);
    return footerData.slice(startIndex, endIndex);
  });

  useEffect(() => {
    const buildString = navigator.userAgent.includes("Build");
    const sysType = navigator.userAgent.includes("Linux");
    const osType = navigator.userAgent.includes("Android");
    setWebview(buildString && sysType && osType);
  }, []);

  if (webview) {
    return <></>;
  }

  return (
    <footer className="bg-[#200E32] xl:flex xl:justify-center xl:items-center xl:flex-col text-white px-[1em] py-[4em] text-sm">
      <div className="grid grid-cols-[1fr, 2fr, 1fr] max-w-[1152px] xl:w-[1152px]">
        <div className="text-left space-y-3 mb-6">
          <img
            src={footerLogo}
            alt="wishfy logo"
            className="w-[9.625em] lg:w-[8em]"
          />
          <p>© {new Date().getFullYear()} wishfy. All rights reserved</p>
          <p>Follow Us On:</p>
          <div className="flex space-x-4">
            <div className="flex justify-center items-center w-10 h-10 border-[1px] rounded-full hover:bg-[#1ec5f7]">
              <a
                href="https://in.linkedin.com/company/wishfy-technologies"
                style={{ color: "white" }}
                target="_blank"
                rel="noreferrer"
              >
                <BiLogoLinkedin color="white" size={22} />
              </a>
            </div>

            <div className="flex justify-center items-center w-10 h-10 border-[1px] rounded-full hover:bg-[#1ec5f7]">
              <a
                href="https://x.com/wishfyofficial"
                style={{ color: "white" }}
                target="_blank"
                rel="noreferrer"
              >
                <BiLogoTwitter color="white" size={22} />
              </a>
            </div>
            <div className="flex justify-center items-center w-10 h-10 border-[1px] rounded-full hover:bg-[#1ec5f7]">
              <a
                href="https://www.instagram.com/wishfy.official/"
                style={{ color: "white" }}
                target="_blank"
                rel="noreferrer"
              >
                <BiLogoInstagramAlt size={22} />
              </a>
            </div>
            <div className="flex justify-center items-center w-10 h-10 border-[1px] rounded-full hover:bg-[#1ec5f7]">
              <a
                href="https://www.facebook.com/profile.php?id=61554507296223"
                style={{ color: "white" }}
                target="_blank"
                rel="noreferrer"
              >
                <BiLogoFacebook color="white" size={22} />
              </a>
            </div>
          </div>
        </div>

        <div>
          <div className="space-y-1 text-left mb-4 hover:underline-offset-1">
            <ul className="grid grid-cols-2 md:grid-cols-3 gap-x-12">
              {columns.map((column, columnIndex) => (
                <div key={columnIndex} className="col-span-1">
                  {column.map((item, index) => (
                    <Link to={item.link} key={index} className=" block mb-1">
                      {item.title}
                    </Link>
                  ))}
                </div>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-end space-y-5 mb-8 xsm:flex-row sm:flex-row xsm:space-y-0 sm:space-x-3 sm:col-start-1 sm:col-end-4 lg:flex-col lg:space-y-3 lg:space-x-0 lg:col-start-3 lg:col-end-4 ">
          <Link
            to={"https://play.google.com/store/apps/details?id=com.Wishfy.io"}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-black w-[180px] md:max-w-[150px] rounded-md flex justify-center items-center p-1 "
          >
            <div>
              <BiLogoPlayStore color="black" size={35} />
            </div>
            <div>
              <p className="text-[10px] font-semibold text-gray-400 text-left mb-0">
                GET IT ON
              </p>
              <p className="text-lg font-semibold -mt-2 text-gray-600 ">
                Google Play
              </p>
            </div>
          </Link>

          <Link
            to="#"
            rel="noopener noreferrer"
            className="bg-white text-black w-[180px] md:max-w-[150px] rounded-md flex justify-center items-center p-1 "
          >
            <div>
              <BiLogoApple color="black" size={35} />
            </div>
            <div>
              <p className="text-[10px] font-semibold text-gray-400 text-left mb-0">
                DOWNLOAD ON THE
              </p>
              <p className="text-lg text-left font-semibold -mt-2 text-gray-600 ">
                App Store
              </p>
            </div>
          </Link>
        </div>
      </div>

      <div className="flex justify-around flex-col space-y-5 md:flex-row xl:w-[1152px]">
        <div className="flex justify-start items-center">
          {/* <img className="w-14" src={returnPolicy} alt="play-store" /> */}
          <BiRepeat color="white" size={34} />
          <p className="ml-1 text-left">
            <span className="text-[#FB1648] font-bold">
              Return within 24 hours
            </span>{" "}
            of <br /> receiving your order
          </p>
        </div>

        <div className="flex justify-start items-center">
          {/* <img className="w-14" src={originalTag} alt="play-store" /> */}
          <BiCheckShield color="white" size={34} />
          <p className="ml-1 text-left">
            <span className="text-[#FB1648] font-bold">100% ORIGINAL</span>{" "}
            guarantee for
            <br /> all products at wishfy.io
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
